module.exports = __webpack_public_path__ + "static/media/ruspolia_nitidula.a434fd5e.png";